import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Blogbred from '../../Global/Blogbred';
import Teamdetails2 from '../Mainblogdetails/Teamdetail2';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (    
        <>
        {/* <Preloader/> */}
            <Headertwo />
            <Blogbred title="10 Things Every NRI Should Know About OCI Card"/>
            <Teamdetails2/>
            {/* <Ctaone/> */}
            <Footer/>
            <BackToTop/>
        </>
    )
}
export default Main;